<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-4 p-mr-4 p-mb-2">
                <div class="p-formgrid p-grid p-col-12 p-ml-2">
                    <div class="p-col-12 p-lg-6">
                        <div class="p-formgrid p-grid">
                            <div class="p-field p-col-12 p-lg-6">
                                <label class="p-mr-2">{{ $t('organize_response') }}</label>
                                <Button @click="showOrganize = true" icon="pi pi-plus" class="p-button-success" /><label class="p-ml-2">{{
                                    $t('group_large')
                                }}</label>
                            </div>
                            <div class="p-field p-col-12 p-lg-6">
                                <Button @click="showOrganize2 = true" icon="pi pi-plus" class="p-button-success" /><label class="p-ml-2">{{
                                    $t('group_small')
                                }}</label>
                            </div>
                        </div>

                        <div class="p-field p-col p-mt-2" style="margin-left: -10px">
                            <DataTable
                                :value="organize_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="5"
                                dataKey="id"
                                ref="dt"
                                :rowHover="true"
                                :selection.sync="selectedOrganizeData"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                :rowsPerPageOptions="[5, 10, 20, 50]"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="organize_name" :header="$t('id_operating_name')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div hidden>{{ dataTable.data.organize_id }}</div>
                                        {{ dataTable.data.organize_name }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        organizeDelete = dataTable.data;
                                                        alertDisplay(organizeDelete);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                    :disabled="is_pressed == true"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <div class="p-col-12 p-lg-6 p-mt-2">
                        <div class="p-formgrid p-grid">
                            <div class="p-field p-col-11 p-lg-11">
                                <label>{{ $t('label_type_device') }}</label>
                                <MultiSelect
                                    v-model="deviceTypeSelected"
                                    :options="deviceTypeOptions"
                                    optionLabel="system_name"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :filter="true"
                                    class="multiselect-custom"
                                    :clearFilterMultiSelect="multiSelectClearFilerValue"
                                >
                                    <template #value="slotProps">
                                        <div class="item item-value" v-for="option of slotProps.value" :key="option.id">
                                            <div>{{ option.system_name }}</div>
                                        </div>
                                        <template v-if="!slotProps.value || slotProps.value.length === 0">
                                            {{ $t('placeholderSelectBox') }}
                                        </template>
                                    </template>
                                    <template #option="slotProps">
                                        <div class="item">
                                            <div>{{ slotProps.option.system_name }}</div>
                                        </div>
                                    </template>
                                </MultiSelect>
                            </div>
                            <div class="p-field p-col-1 p-lg-1 p-mt-5">
                                <Button
                                    @click="
                                        deviceTypeSelected = null;
                                        multiSelectClearFilerValue += 1;
                                    "
                                    icon="pi pi-times"
                                    class="p-button-danger p-mt-2"
                                />
                            </div>
                        </div>
                        <span v-if="error_text_default === true" style="color: red">
                            กรุณาเลือกตัวเลือกประเภทเครื่องมือ/อุปกรณ์ อย่างน้อย 1 ตัวเลือก
                        </span>

                        <!-- <span class="p-invalid" v-if="error_device == true">{{$t('table_validate')}}</span> -->

                        <!-- + เงื่อนไข -->
                        <div v-if="deviceTypeSelected != null">
                            <div v-if="deviceTypeSelected.length == '2'">
                                <!-- 1 ถ้าเลือกแล้วมียานพาหนะ -->
                                <div v-if="deviceTypeSelected[0].system_id == 'gs-00000002' || deviceTypeSelected[1].system_id == 'gs-00000002'">
                                    <div class="p-formgrid p-grid p-mt-2">
                                        <div class="p-field p-col-11 p-lg-11 p-mt-2">
                                            <label>{{ $t('label_type_vehicle') }}</label>
                                            <MultiSelect
                                                v-model="vehicleSelected"
                                                :options="vehicleOptions"
                                                optionLabel="system_name"
                                                :placeholder="$t('placeholderSelectBox')"
                                                :filter="true"
                                                class="multiselect-custom"
                                                :clearFilterMultiSelect="multiSelectClearFilerValue"
                                                @change="filterVehicleOptions"
                                            >
                                                <template #value="slotProps">
                                                    <div class="item item-value" v-for="option of slotProps.value" :key="option.id">
                                                        <div>{{ option.system_name }}</div>
                                                    </div>
                                                    <template v-if="!slotProps.value || slotProps.value.length === 0">
                                                        {{ $t('placeholderSelectBox') }}
                                                    </template>
                                                </template>
                                                <template #option="slotProps">
                                                    <div class="item">
                                                        <div>{{ slotProps.option.system_name }}</div>
                                                    </div>
                                                </template>
                                            </MultiSelect>
                                        </div>
                                        <div class="p-field p-col-1 p-lg-1 p-mt-5">
                                            <Button
                                                @click="
                                                    vehicleSelected = null;
                                                    multiSelectClearFilerValue += 1;
                                                "
                                                icon="pi pi-times"
                                                class="p-button-danger p-mt-2"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <!--end 1 ถ้าเลือกแล้วมียานพาหนะ -->
                            </div>

                            <div v-if="deviceTypeSelected.length == '1'">
                                <!-- 2 ถ้าเลือกแค่ยานพาหนะ -->

                                <div v-if="deviceTypeSelected[0].system_id == 'gs-00000002'">
                                    <div class="p-formgrid p-grid p-mt-2">
                                        <div class="p-field p-col-11">
                                            <label>{{ $t('label_type_vehicle') }}</label>
                                            <MultiSelect
                                                v-model="vehicleSelected"
                                                :options="vehicleOptions"
                                                optionLabel="system_name"
                                                :placeholder="$t('placeholderSelectBox')"
                                                :filter="true"
                                                class="multiselect-custom"
                                                :clearFilterMultiSelect="multiSelectClearFilerValue"
                                                @change="filterVehicleOptions"
                                            >
                                                <template #value="slotProps">
                                                    <div class="item item-value" v-for="option of slotProps.value" :key="option.id">
                                                        <div>{{ option.system_name }}</div>
                                                    </div>
                                                    <template v-if="!slotProps.value || slotProps.value.length === 0">
                                                        {{ $t('placeholderSelectBox') }}
                                                    </template>
                                                </template>
                                                <template #option="slotProps">
                                                    <div class="item">
                                                        <div>{{ slotProps.option.system_name }}</div>
                                                    </div>
                                                </template>
                                            </MultiSelect>
                                        </div>
                                        <div class="p-field p-col-1 p-mt-5">
                                            <Button
                                                @click="
                                                    vehicleSelected = null;
                                                    multiSelectClearFilerValue += 1;
                                                "
                                                icon="pi pi-times"
                                                class="p-button-danger p-mt-2"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    {{ (vehicleSelected = null) }}
                                </div>

                                <!--end 2 ถ้าเลือกแค่ยานพาหนะ -->
                            </div>
                        </div>
                        <div class="p-formgrid p-grid">
                            <div class="p-field p-col-11 p-lg-11">
                                <label>{{ $t('label_standardName') }}</label>
                                <MultiSelect
                                    v-model="standardNameSelected"
                                    :options="standardNameOptions"
                                    optionLabel="system_name"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :filter="true"
                                    class="multiselect-custom"
                                    :clearFilterMultiSelect="multiSelectClearFilerValue"
                                >
                                    <template #value="slotProps">
                                        <div class="item item-value" v-for="option of slotProps.value" :key="option.id">
                                            <div>{{ option.system_name }}</div>
                                        </div>
                                        <template v-if="!slotProps.value || slotProps.value.length === 0">
                                            {{ $t('placeholderSelectBox') }}
                                        </template>
                                    </template>
                                    <template #option="slotProps">
                                        <div class="item">
                                            <div>{{ slotProps.option.system_name }}</div>
                                        </div>
                                    </template>
                                </MultiSelect>
                            </div>
                            <div class="p-field p-col-1 p-lg-1 p-mt-5">
                                <Button
                                    @click="
                                        standardNameSelected = null;
                                        multiSelectClearFilerValue += 1;
                                    "
                                    icon="pi pi-times"
                                    class="p-button-danger p-mt-2"
                                />
                            </div>
                            <span v-if="error_text === true" style="color: red"> กรุณาเลือกชื่อเครื่องมือฯ (ชื่อมาตรฐาน) อย่างน้อย 1 ตัวเลือก </span>
                        </div>

                        <div class="p-formgrid p-grid p-mt-4 p-jc-end">
                            <div class="p-field p-col p-mt-2">
                                <Button @click="clearSearchField()" :label="$t('clearBtn')" class="p-button-clear p-mr-3" />
                                <Button
                                    @click="
                                        search();
                                        cou = true;
                                    "
                                    :label="$t('searchBtn')"
                                    class="p-button-info p-mr-2"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="body_dataPDF.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>

        <!-- :contentStyle="{'overflow-y': 'scroll'}" -->
        <Dialog :modal="true" :header="$t('OrganizeModalHeader1')" :visible.sync="showOrganize" :style="{ width: '80%' }">
            <div style="max-height: 600px; overflow-y: auto">
                <organize-table-modified
                    @selectOrganization="selectedOrganize_passValue"
                    :parentmessage="parentmessage_organize"
                ></organize-table-modified>
            </div>
        </Dialog>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader2')" :visible.sync="showOrganize2" :style="{ width: '80%' }">
            <div style="max-height: 600px; overflow-y: auto">
                <organize-table-modified2
                    @selectOrganization="selectedOrganize_passValue2"
                    :parentmessage="parentmessage_organize2"
                ></organize-table-modified2>
            </div>
        </Dialog>

        <div class="card p-fluid p-mt-2">
            <DataTable
                :value="body_dataPDF"
                :scrollable="true"
                scrollHeight="600px"
                :paginator="true"
                :rows="10"
                dataKey="id"
                ref="dt_PDF"
                :rowHover="true"
                :filters="filters"
                :sortOrder="1"
                sortField="number"
                :loading="loading"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                rowGroupMode="rowspan"
                groupRowsBy="org"
            >
                <template #header>
                    <div class="p-grid p-col">
                        <div class="table-header" style="padding: 7px">
                            <Button @click="exportExcel()" :label="$t('exportBtn')" class="p-button-info" style="background-color: green" />
                        </div>
                        <div class="table-header" style="padding: 7px">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <span class="p-input-icon-left" v-if="columns_disabled && cou">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="searchTable()" :placeholder="$t('searchHeader')" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" @input="searchTable()" :placeholder="$t('searchHeader')" />
                            </span>
                        </div>
                    </div>
                </template>

                <template #empty>{{ $t('TableEmpty') }}</template>

                <Column field="org" header="หน่วยงาน" :sortable="true" headerStyle="width: 15rem">
                    <template #body="{ data }">
                        {{ data.org }}
                    </template>
                </Column>
                <Column field="status" header="สถานะ" :headerStyle="{ width: '10rem', textAlign: 'center' }">
                    <template #body="{ data }">
                        <!-- {{ data.status }} -->
                        <div v-if="data.status == 'พร้อมใช้'" class="table_row">
                            <div class="table_statusColor" style="background-color: #58d68d">
                                {{ data.status }}
                            </div>
                        </div>
                        <div v-else-if="data.status == 'ซ่อม/ชำรุด'" class="table_row">
                            <div class="table_statusColor" style="background-color: #e74c3c">
                                {{ data.status }}
                            </div>
                        </div>
                        <div v-else-if="data.status == 'ซ่อม'" class="table_row">
                            <div class="table_statusColor" style="background-color: #dd0000">
                                {{ data.status }}
                            </div>
                        </div>
                        <div v-else-if="data.status == 'ชำรุด'" class="table_row">
                            <div class="table_statusColor" style="background-color: #e74c3c">
                                {{ data.status }}
                            </div>
                        </div>
                        <div v-else-if="data.status == 'รอจำหน่าย'" class="table_row">
                            <div class="table_statusColor" style="background-color: #f1948a">
                                {{ data.status }}
                            </div>
                        </div>
                        <div v-else-if="data.status == '-'" class="table_row">
                            <div class="table_statusColor" style="background-color: #fff">
                                {{ data.status }}
                            </div>
                        </div>
                        <div v-else class="table_row">
                            <div class="table_statusColor" style="background-color: #fadbd8">
                                {{ data.status }}
                            </div>
                        </div>
                    </template>
                </Column>
                <div v-for="stan_name in setStandardName" :key="stan_name.system_name">
                    <Column :field="stan_name.system_name" :header="stan_name.system_name" :headerStyle="{ maxWidth: '10rem', minWidth: '7rem' }">
                        <template #body="{ data }">
                            <div>
                                {{ !data[stan_name.system_name] ? '-' : data[stan_name.system_name] }}
                            </div>
                        </template>
                    </Column>
                </div>

                <div v-if="setStandardName !== null">
                    <Column field="sum" header="รวม" headerStyle="width: 8rem;">
                        <template #body="{ data }">
                            {{ data.sum }}
                        </template>
                    </Column>
                </div>
            </DataTable>
        </div>
        <!-- อะไรไม่รู้ ไม่ได้ใช้-->
        <div class="card p-fluid p-mt-2">
            <DataTable
                id="tbl_excel"
                :value="body_dataPDF"
                :rows="10"
                dataKey="id"
                ref="dt_PDF"
                :rowHover="true"
                :filters="filters"
                :sortOrder="1"
                sortField="number"
                :loading="loading"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                rowGroupMode="rowspan"
                groupRowsBy="org"
                style="display: none"
            >
                <template #header>
                    <div class="p-grid p-col">
                        <div class="table-header" style="padding: 7px">
                            <Button @click="exportExcel()" :label="$t('exportBtn')" class="p-button-info" style="background-color: green" />
                        </div>
                        <div class="table-header" style="padding: 7px">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <span class="p-input-icon-left" v-if="columns_disabled && cou">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="searchTable()" :placeholder="$t('searchHeader')" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" @input="searchTable()" :placeholder="$t('searchHeader')" />
                            </span>
                        </div>
                    </div>
                </template>

                <template #empty>{{ $t('TableEmpty') }}</template>

                <Column field="org" header="หน่วยงาน" :sortable="true" headerStyle="width: 15rem">
                    <template #body="dataTable">
                        {{ dataTable.data.org }}
                    </template>
                </Column>

                <Column field="status" header="สถานะ" :headerStyle="{ width: '10rem', textAlign: 'center' }">
                    <template #body="dataTable">
                        <!-- {{ dataTable.data.status }} -->
                        <div v-if="dataTable.data.status == 'พร้อมใช้'" class="table_row">
                            <div class="table_statusColor" style="background-color: #58d68d">
                                {{ dataTable.data.status }}
                            </div>
                        </div>
                        <div v-else-if="dataTable.data.status == 'ซ่อม'" class="table_row">
                            <div class="table_statusColor" style="background-color: #dd0000">
                                {{ dataTable.data.status }}
                            </div>
                        </div>
                        <div v-else-if="dataTable.data.status == 'ซ่อม/ชำรุด'" class="table_row">
                            <div class="table_statusColor" style="background-color: #e74c3c">
                                {{ dataTable.data.status }}
                            </div>
                        </div>
                        <div v-else-if="dataTable.data.status == 'ชำรุด'" class="table_row">
                            <div class="table_statusColor" style="background-color: #e74c3c">
                                {{ dataTable.data.status }}
                            </div>
                        </div>
                        <div v-else-if="dataTable.data.status == 'รอจำหน่าย'" class="table_row">
                            <div class="table_statusColor" style="background-color: #f1948a">
                                {{ dataTable.data.status }}
                            </div>
                        </div>
                        <div v-else-if="dataTable.data.status == '-'" class="table_row">
                            <div class="table_statusColor" style="background-color: #fff">
                                {{ dataTable.data.status }}
                            </div>
                        </div>
                        <div v-else class="table_row">
                            <div class="table_statusColor" style="background-color: #fadbd8">
                                {{ dataTable.data.status }}
                            </div>
                        </div>
                    </template>
                </Column>
                <div v-for="stan_name in setStandardName" :key="stan_name.system_name">
                    <Column :field="stan_name.system_name" :header="stan_name.system_name" :headerStyle="{ maxWidth: '20rem', minWidth: '15rem' }">
                        <template #body="dataTable">
                            <div>
                                {{
                                    dataTable.data[stan_name.system_name] === undefined || dataTable.data[stan_name.system_name] === null
                                        ? '-'
                                        : dataTable.data[stan_name.system_name]
                                }}
                            </div>
                        </template>
                    </Column>
                </div>

                <div v-if="setStandardName !== null">
                    <Column field="sum" header="รวม" headerStyle="width: 8rem;">
                        <template #body="dataTable">
                            {{ dataTable.data.sum === undefined || dataTable.data.sum === null ? '-' : dataTable.data.sum }}
                        </template>
                    </Column>
                </div>
            </DataTable>
        </div>

        <Dialog :modal="true" :header="$t('ConfirmDelete')" :visible.sync="displayConfirmation" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <i class="pi pi-exclamation-triangle p-mr-3 p-mt2" style="font-size: 2rem" />
                <span>{{ $t('ConfirmDeleteSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="confirmDelete()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>

        <template>
            <div>
                <div v-for="stan_name in setStandardName" :key="stan_name.system_name">
                    <DataTable
                        :value="groupedByOrgAndStandardWithSum(stan_name.system_name)"
                        :scrollable="true"
                        scrollHeight="400px"
                        id="tbl_excel"
                        ref="xl"
                        :rowHover="true"
                        style="display: none"
                    >
                        <Column field="org" header="" :headerStyle="{ width: '200px', textAlign: 'center' }">
                            <template #header>
                                <div>หน่วยงาน</div>
                            </template>
                            <template #body="slotProps">
                                <div style="text-align: center">{{ slotProps.data.org || '-' }}</div>
                            </template>
                        </Column>

                        <Column :field="stan_name.system_name" :header="stan_name.system_name" :headerStyle="{ width: '100px', textAlign: 'center' }">
                            <template #body="slotProps">
                                <div style="text-align: center">{{ slotProps.data.value || '-' }}</div>
                            </template>
                        </Column>

                        <Column field="ready" header="พร้อมใช้" :headerStyle="{ width: '100px', textAlign: 'center' }">
                            <template #body="slotProps">
                                <div class="table_row" style="text-align: center">
                                    <div v-if="slotProps.data.status === 'พร้อมใช้'">{{ slotProps.data.value || '-' }}</div>
                                    <div v-else>-</div>
                                </div>
                            </template>
                        </Column>

                        <Column field="repair" header="ซ่อมแซม/ชำรุด" :headerStyle="{ width: '100px', textAlign: 'center' }">
                            <template #body="slotProps">
                                <div class="table_row" style="text-align: center">
                                    <div v-if="slotProps.data.status === 'ซ่อม/ชำรุด'">{{ slotProps.data.value || '-' }}</div>
                                    <div v-else>-</div>
                                </div>
                            </template>
                        </Column>

                        <Column field="sum" header="รวม" :headerStyle="{ width: '100px', textAlign: 'center' }">
                            <template #body="slotProps">
                                <div class="table_row" style="text-align: center">
                                    {{ slotProps.data.sum || '-' }}
                                </div>
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import organizeTableModified from '../OrganizeMultiSelectTable';
import organizeTableModified2 from '../OrganizeMultiSelectTableModified2';
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
import { jsPDF } from 'jspdf';
import { font } from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ

import * as XLSX from 'xlsx';

import moment from 'moment';
import textFooter from '../../../mixins/textFooter_Search_html';
import { Column } from 'jspdf-autotable';
// import { Dropdown } from "primevue/dropdown";

export default {
    name: 'report-equipment-investigation',
    components: {
        organizeTableModified,
        organizeTableModified2,
        textFooter
        // Dropdown
    },

    data: () => ({
        filteredBodyDataPDF: [],
        is_pressed: false,
        multiSelectClearFilerValue: 0,
        date: moment().locale('th').add(543, 'year').format('l'),
        // Doe ค้นหา  2/5
        filter: '',
        cou: false,
        cloneTable: [],
        // Doe ค้นหา  2/5 จบ

        table: [],
        filters: {},
        displayConfirmation: false,
        showOrganize: false,
        showOrganize2: false,
        deviceTypeOptions: [],
        deviceTypeSelected: null,

        vehicleOptions: [],
        vehicleSelected: null,

        standardNameOptions: [],
        standardNameOptionsBackup: [],
        standardNameSelected: null,

        selectedOrganizeData: null,
        organize_table: [],

        organizeDelete: null,

        error_device: false,
        error_vehicle: false,
        error_standardName: false,
        error_text_default: false,
        error_text_default_vehicle: false,
        error_text: false,

        loading: false,

        parentmessage_organize: null,
        parentmessage_organize2: null,
        //
        text_Footer: false,
        Clone_Data_text_Footer: [],
        Data_text_Footer: [
            {
                DataName: 'หน่วยงานรับผิดชอบ',
                textShow: ''
            },
            {
                DataName: 'ประเภทเครื่องมือ/อุปกรณ์',
                textShow: ''
            },
            {
                DataName: 'ประเภทยานพาหนะ',
                textShow: ''
            },
            {
                DataName: 'ชื่อเครื่องมือฯ (ชื่อมาตรฐาน)',
                textShow: ''
            }
        ],

        setStandardName: null,
        // Doe PDF เลือกได้  2/5
        head_PDF: [],
        column_PDF: [],
        body_dataPDF: [],
        body_data_PDF: [],
        fill_row_detail: [
            {
                name_row: 'status',
                detail_row: [
                    {
                        check_text: 'พร้อมใช้',
                        fill_color: [88, 214, 141]
                    },
                    {
                        check_text: 'ซ่อม',
                        fill_color: [221, 0, 0]
                    },
                    {
                        check_text: 'ชำรุด',
                        fill_color: [231, 76, 60]
                    },
                    {
                        check_text: 'รอจำหน่าย',
                        fill_color: [241, 148, 138]
                    },
                    {
                        check_text: 'จำหน่าย',
                        fill_color: [250, 219, 216]
                    },
                    {
                        check_text: 'ซ่อม/ชำรุด',
                        fill_color: [231, 76, 60]
                    }
                ]
            }
        ],
        Body_rowSpanPDF: [],
        Body_setCenterPDF: [],

        setPDF_Hor: 'l',
        setPosition_Hor: [802, 34, 802, 570],
        setPDF_Ver: 'p',
        setPosition_Ver: [570, 34, 575, 815],
        setPositionTopic_Ver: [295, 15],
        setPositionTopic_Hor: [450, 15],
        setPositionFooter_Ver: [20, 815],
        setPositionFooter_Hor: [20, 570],
        setPositionFooter_Ver2: [39, 825],
        setPositionFooter_Hor2: [39, 580],
        setPDF_Styles: 'grid',
        setnamePDF: 'ตารางสรุปรายงานความพร้อมเครื่องมือ อุปกรณ์/ยานพาหนะ',
        setPDF_fillColor: [95, 154, 250],
        setPDF_Margin: { left: 15, right: 15 },

        PDF_minCellWidthVer: 40,
        PDF_FontHeaderVer: 7.5,
        PDF_FontBodyVer: 5.5,

        PDF_BodySizeSelect: {},
        PDF_BodySize: {
            index: { cellWidth: 21.5 },
            ev_name: { cellWidth: 28 },
            ev_standard_name: { cellWidth: 40 },
            group: { cellWidth: 42, fontSize: 6 },
            system_name: { cellWidth: 38, fontSize: 6 },
            ev_number: { cellWidth: 35 },
            ev_license_plate: { cellWidth: 35 },
            ev_sidecar_number: { cellWidth: 38 },
            organize_name: { cellWidth: 45 },

            text_tel_detail: { cellWidth: 28 },
            // ev_response_phone:{cellWidth:28},

            ev_detail: { cellWidth: 33 },
            ev_response_name: { cellWidth: 42 },

            status: { cellWidth: 27 },
            ev_amount: { cellWidth: 24.5 },
            // user_fullname:{cellWidth:48.5},
            ev_date: { cellWidth: 37 }
        },

        PDF_minCellWidthHor: 50,
        PDF_FontHeaderHor: 12,
        PDF_FontBodyHor: 10,

        PDF_BodySizeHorSelect: {},
        PDF_BodySizeHor: {
            index: { cellWidth: 30 },
            ev_name: { cellWidth: 55 },
            ev_standard_name: { cellWidth: 70 },
            group: { cellWidth: 60, fontSize: 10 },
            system_name: { cellWidth: 60, fontSize: 10 },
            ev_number: { cellWidth: 50 },
            ev_license_plate: { cellWidth: 50 },
            ev_sidecar_number: { cellWidth: 45 },
            organize_name: { cellWidth: 70 },

            text_tel_detail: { cellWidth: 40 },
            // ev_response_phone:{cellWidth:40},

            ev_detail: { cellWidth: 49 },
            ev_response_name: { cellWidth: 50 },

            status: { cellWidth: 40 },
            ev_amount: { cellWidth: 35 },
            ev_date: { cellWidth: 55, fontSize: 10 }
        },
        columns: [
            { title: 'ลำดับ', dataKey: 'index' },
            { title: 'ชื่อเครื่องมือฯ', dataKey: 'ev_name' },
            { title: 'ชื่อเครื่องมือฯ(ชื่อมาตรฐาน)', dataKey: 'ev_standard_name' },
            { title: 'กลุ่มเครื่องมือฯ', dataKey: 'group' },
            { title: 'ประเภทเครื่องมือฯ', dataKey: 'system_name' },
            { title: 'หมายเลขครุภัณฑ์', dataKey: 'ev_number' },
            { title: 'เลขทะเบียน', dataKey: 'ev_license_plate' },
            { title: 'หมายเลขข้างรถ', dataKey: 'ev_sidecar_number' },
            { title: 'หน่วยงานที่รับผิดชอบ', dataKey: 'organize_name' },
            { title: 'สถานะ', dataKey: 'status' },
            { title: 'รายละเอียดเพิ่มเติม', dataKey: 'ev_detail' },
            { title: 'จำนวน', dataKey: 'ev_amount' },
            { title: 'ผู้รับผิดชอบ(สังกัด)', dataKey: 'ev_response_name' },
            // {title: "เบอร์โทร", dataKey: "ev_response_phone"},
            { title: 'เบอร์โทร', dataKey: 'text_tel_detail' },
            { title: 'วันที่ปรับปรุงล่าสุด', dataKey: 'ev_date' },
            { title: 'ผู้แก้ไข', dataKey: 'user_fullname' }
        ],

        columnsSelector: null,
        columnsSelectorDialog: null,

        displayEditPDF: false,

        columns_index: true,
        columns_ev_name: true,
        columns_ev_standard_name: true,
        columns_group: true,
        columns_system_name: true,
        columns_ev_number: true,
        columns_ev_license_plate: true,
        columns_ev_sidecar_number: true,

        columns_organize_name: true,
        columns_status: true,
        columns_ev_detail: true,
        columns_ev_amount: true,
        columns_ev_response_name: true,
        columns_ev_response_phone: true,
        columns_ev_date: true,
        columns_user_fullname: true,

        columns_disabled: true,
        GetData_ColumnsSearch: [],
        // Doe PDF เลือกได้  2/5  จบ

        // Doe : PDF 3/3
        items: []
        // Doe : PDF 3/3 จบ
    }),
    watch: {
        showOrganize2(val) {
            // this.is_pressed = false
            if (val == true) {
                if (this.organize_table.length > 0) {
                    this.parentmessage_organize2 = this.organize_table;
                } else {
                    this.parentmessage_organize2 = [];
                }
            }
        },
        deviceTypeOptions(val) {
            if (val != null) {
                this.deviceTypeSelected = val;
            }
        },

        vehicleOptions(val) {
            if (val != null) {
                this.vehicleSelected = val;
            }
        },
        standardNameOptions(val) {
            if (val != null) {
                this.standardNameSelected = val;
            }
        },

        async deviceTypeSelected(val) {
            if (val != null) {
                this.error_device = false;
                for (const item of val) {
                    // console.log(item)
                    if (this.deviceTypeSelected.length === 2) {
                        await this.axios
                            .post(`${this.$url_service}/initial/option`, {
                                body: { group: 'dg-23' }
                            })
                            .then((response) => {
                                this.standardNameOptions = response.data.data;
                                this.standardNameOptionsBackup = response.data.data;
                            });
                    } else if (this.deviceTypeSelected.length === 1 && item.system_id === 'gs-00000001') {
                        await this.axios
                            .post(`${this.$url_service}/initial/option`, {
                                body: { topic: 'gs-00000001', group: 'dg-23' }
                            })
                            .then((response) => {
                                this.standardNameOptions = response.data.data;
                                this.standardNameOptionsBackup = response.data.data;
                            });
                    } else if (this.deviceTypeSelected.length === 1 && item.system_id === 'gs-00000002') {
                        await this.axios
                            .post(`${this.$url_service}/initial/option`, {
                                body: { topic: 'gs-00000002', group: 'dg-23' }
                            })
                            .then((response) => {
                                this.standardNameOptions = response.data.data;
                                this.standardNameOptionsBackup = response.data.data;
                            });
                    }
                }

                if (val.length === 0) {
                    this.deviceTypeSelected = null;
                }
            }
        },

        vehicleSelected(val) {
            if (val != null) {
                this.error_vehicle = false;
                if (val.length == 0) {
                    this.vehicleSelected = null;
                }
            }
        },

        standardNameSelected(val) {
            if (val != null) {
                this.error_standardName = false;
                if (val.length == 0) {
                    this.standardNameSelected = null;
                }
            }
        },

        table(val) {
            if (val.length > 0) {
                this.loading = false;
                // this.loading = true;
            }
        },
        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.table = [];
            } else {
                this.table = this.cloneTable;
            }
        }
    },
    async created() {
        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;

        // Doe PDF เลือกได้  4/5  จบ

        await this.axios
            .post(`${this.$url_service}/initial/option`, {
                body: { group: 'dg-09' }
            })
            .then((response) => {
                this.deviceTypeOptions = response.data.data;
            });
        await this.axios
            .post(`${this.$url_service}/initial/option`, {
                body: { group: 'dg-10' }
            })
            .then((response) => {
                this.vehicleOptions = response.data.data;
            });
        await this.axios
            .post(`${this.$url_service}/initial/option`, {
                body: { group: 'dg-23' }
            })
            .then((response) => {
                this.standardNameOptions = response.data.data;
                this.standardNameOptionsBackup = response.data.data;
            });

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },

    mounted() {
        this.items = [
            {
                label: ' แนวตั้ง',
                command: () => this.exportPDFVertical()
            },
            {
                label: 'แนวนอน',
                command: () => this.exportPDFHorizontal()
            }
        ];
    },

    computed: {
        filteredData() {
            return this.body_dataPDF.filter((item) => item && item.sum && item.org !== 'รวม' && item.org !== 'รวมทั้งสิ้น');
        },
        lastYearTotal() {
            let total = 0;
            for (let sale of this.sales) {
                total += sale.lastYearProfit;
            }

            return this.formatCurrency(total);
        },
        thisYearTotal() {
            let total = 0;
            for (let sale of this.sales) {
                total += sale.thisYearProfit;
            }

            return this.formatCurrency(total);
        }
    },
    methods: {
        groupedByOrgAndStandardWithSum(standardName) {
            const groupedData = this.groupedByOrgAndStandard(standardName);

            // Get all unique organizations from this.organize_table
            const allOrgs = this.organize_table.map((org) => org.organize_name);

            // Create a map to easily look up data for each org
            const dataMap = new Map(groupedData.map((item) => [item.org, item]));

            // Create the final array with data for all orgs
            const finalData = allOrgs.map((org) => {
                const existingData = dataMap.get(org);
                return (
                    existingData || {
                        org: org,
                        status: 'พร้อมใช้', // Default status
                        value: 0,
                        sum: 0
                    }
                );
            });

            // Compute the total row
            const totalRow = {
                org: 'รวมทั้งสิ้น',
                status: 'รวม',
                value: this.sumColumnData(finalData, 'value'),
                sum: this.sumColumnData(finalData, 'sum')
            };

            return [...finalData, totalRow];
        },

        groupedByOrgAndStandard(standardName) {
            // Get all unique organizations from this.organize_table
            const allOrgs = this.organize_table.map((org) => org.organize_name);

            // Create a map to store data for each org
            const orgDataMap = new Map();

            this.body_dataPDF
                .filter((item) => item[standardName])
                .forEach((item) => {
                    if (item.org !== 'รวม' && item.org !== 'รวมทั้งสิ้น') {
                        const existingData = orgDataMap.get(item.org) || {
                            org: item.org,
                            ready: 0,
                            repair: 0,
                            value: 0,
                            sum: 0
                        };

                        if (item.status === 'พร้อมใช้') {
                            existingData.ready += parseInt(item[standardName]) || 0;
                        } else if (item.status === 'ซ่อม/ชำรุด') {
                            existingData.repair += parseInt(item[standardName]) || 0;
                        }

                        existingData.value += parseInt(item[standardName]) || 0;
                        existingData.sum += parseInt(item.sum) || 0;

                        orgDataMap.set(item.org, existingData);
                    }
                });

            // Create the final array with data for all orgs
            return allOrgs.map((org) => {
                const data = orgDataMap.get(org) || {
                    org: org,
                    ready: 0,
                    repair: 0,
                    value: 0,
                    sum: 0
                };
                return {
                    org: data.org,
                    status: data.ready > data.repair ? 'พร้อมใช้' : 'ซ่อม/ชำรุด',
                    value: data.value,
                    sum: data.sum
                };
            });
        },

        exportExcel() {
            const workbook = XLSX.utils.book_new();

            // Initialize an array for the worksheet data
            let worksheetData = [];

            // Function to get unique organizations from this.organize_table
            const getUniqueOrgs = () => {
                return this.organize_table.map((org) => org.organize_name);
            };

            const uniqueOrgs = getUniqueOrgs();

            console.log('uniqueOrgs', uniqueOrgs);

            // Iterate over each standard name to generate its data and headers
            this.setStandardName.forEach((stan_name, standardIndex) => {
                const tableData = this.groupedByOrgAndStandardWithSum(stan_name.system_name);
                const columnOffset = standardIndex * 4;

                // Prepare the header for the current standard
                worksheetData[0] = worksheetData[0] || [];
                worksheetData[0][columnOffset] = {
                    v: stan_name.system_name,
                    t: 's',
                    s: {
                        alignment: {
                            horizontal: 'center',
                            vertical: 'center',
                            wrapText: true
                        }
                    }
                };

                // Header for the columns under this standard
                const columnHeaders = ['หน่วยงาน', 'พร้อมใช้', 'ซ่อมแซม/ชำรุด', 'รวม'];
                worksheetData[1] = worksheetData[1] || [];
                columnHeaders.forEach((header, i) => {
                    worksheetData[1][columnOffset + i] = header;
                });

                // Prepare the data rows for this standard
                let totalReady = 0;
                let totalRepair = 0;
                let totalSum = 0;
                let rowIndex = 2;

                uniqueOrgs.forEach((org) => {
                    const readyData = tableData.find((row) => row.org === org && row.status === 'พร้อมใช้') || { value: 0 };
                    const repairData = tableData.find((row) => row.org === org && row.status === 'ซ่อม/ชำรุด') || { value: 0 };

                    const readyValue = parseInt(readyData.value) || 0;
                    const repairValue = parseInt(repairData.value) || 0;
                    const rowSum = readyValue + repairValue;

                    worksheetData[rowIndex] = worksheetData[rowIndex] || [];
                    worksheetData[rowIndex][columnOffset] = org;

                    if (rowSum === 0) {
                        worksheetData[rowIndex][columnOffset + 1] = { v: `ไม่มี${stan_name.system_name}`, t: 's' };
                        worksheetData[rowIndex][columnOffset + 2] = { v: '', t: 's' };
                        worksheetData[rowIndex][columnOffset + 3] = { v: '', t: 's' };
                    } else {
                        worksheetData[rowIndex][columnOffset + 1] = readyValue;
                        worksheetData[rowIndex][columnOffset + 2] = repairValue;
                        worksheetData[rowIndex][columnOffset + 3] = rowSum;
                    }

                    totalReady += readyValue;
                    totalRepair += repairValue;
                    totalSum += rowSum;

                    rowIndex++;
                });

                // Add the "รวมทั้งสิ้น" row for this standard
                // worksheetData[rowIndex] = worksheetData[rowIndex] || [];
                // worksheetData[rowIndex][columnOffset] = 'รวมทั้งสิ้น';
                // worksheetData[rowIndex][columnOffset + 1] = totalReady;
                // worksheetData[rowIndex][columnOffset + 2] = totalRepair;
                // worksheetData[rowIndex][columnOffset + 3] = totalSum;
            });

            // Remove any undefined rows
            worksheetData = worksheetData.filter((row) => row !== undefined);

            // Create the worksheet
            const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

            // Merge cells for the header and for "ไม่มี" cells
            let mergeRanges = [];
            for (let i = 0; i < this.setStandardName.length; i++) {
                // Merge header cells
                mergeRanges.push({
                    s: { r: 0, c: i * 4 },
                    e: { r: 0, c: i * 4 + 3 }
                });

                // Merge "ไม่มี" cells
                for (let j = 2; j < worksheetData.length; j++) {
                    if (worksheetData[j][i * 4 + 1] && worksheetData[j][i * 4 + 1].v && worksheetData[j][i * 4 + 1].v.startsWith('ไม่มี')) {
                        mergeRanges.push({
                            s: { r: j, c: i * 4 + 1 },
                            e: { r: j, c: i * 4 + 3 }
                        });
                    }
                }
            }

            worksheet['!merges'] = mergeRanges;

            // Set borders and alignment for all cells
            const range = XLSX.utils.decode_range(worksheet['!ref']);
            for (let R = range.s.r; R <= range.e.r; ++R) {
                for (let C = range.s.c; C <= range.e.c; ++C) {
                    const cell_address = { c: C, r: R };
                    const cell_ref = XLSX.utils.encode_cell(cell_address);

                    if (!worksheet[cell_ref]) {
                        worksheet[cell_ref] = { v: '', t: 's' };
                    }

                    // Set cell style
                    if (!worksheet[cell_ref].s) worksheet[cell_ref].s = {};
                    worksheet[cell_ref].s.border = {
                        top: { style: 'thin' },
                        bottom: { style: 'thin' },
                        left: { style: 'thin' },
                        right: { style: 'thin' }
                    };
                    worksheet[cell_ref].s.alignment = {
                        horizontal: 'center',
                        vertical: 'center',
                        wrapText: true
                    };
                }
            }

            // Set column widths
            const cols = [];
            for (let i = 0; i < range.e.c + 1; i++) {
                cols.push({ wch: 15 }); // Set width to 15 characters for all columns
            }
            worksheet['!cols'] = cols;

            // Append the worksheet to the workbook
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

            // Generate Excel file
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

            // Create Blob and download
            const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `ตารางสรุปรายงานความพร้อมเครื่องมือ-${this.date}.xlsx`;
            a.click();
            window.URL.revokeObjectURL(url);
        },

        sumColumnData(data, field) {
            return data.reduce((acc, row) => {
                const value = parseInt(row[field]) || 0;
                return acc + value;
            }, 0);
        },

        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },

        filterVehicleOptions(event) {
            // filter เอาเรือกับรถ
            if ('value' in event && event.value.length) {
                const nameSystem = event.value.map((e) => e.system_name);
                if (nameSystem == this.vehicleOptions.length) {
                    this.standardNameOptions = this.standardNameOptionsBackup;
                    this.standardNameSelected = this.standardNameOptionsBackup;
                } else {
                    const filter = this.standardNameOptionsBackup.filter((x) => nameSystem.some((name) => x.system_name.includes(name)));
                    this.standardNameOptions = filter;
                    this.standardNameSelected = filter;
                }
            } else {
                // * ไม่เลือก *
                // filter ไม่เอาเรือกับรถ
                const filter = this.standardNameOptionsBackup.filter((x) => !x.system_name.includes('รถ') && !x.system_name.includes('เรือ'));
                this.standardNameOptions = filter;
                this.standardNameSelected = filter;
            }
        },

        // exportCSV() {
        //     if (this.$refs.xl != '') {
        //         // debugger;
        //         this.$refs.xl.exportCSV();
        //     }
        // },

        selectedOrganize_passValue(variable) {
            // console.log(variable)
            this.is_pressed = true;
            this.showOrganize = false;
            if (variable != null) {
                this.organize_table = [];
                for (let i = 0; i < variable.length; i++) {
                    this.organize_table.push({
                        organize_id: variable[i].organize_id,
                        organize_name: variable[i].organize_name
                    });
                }
            }
        },
        selectedOrganize_passValue2(variable) {
            // console.log(variable)
            this.is_pressed = false;
            this.showOrganize2 = false;
            if (variable != null) {
                this.organize_table = [];
                for (let i = 0; i < variable.length; i++) {
                    this.organize_table.push({
                        organize_id: variable[i].organize_id,
                        organize_name: variable[i].organize_name
                    });
                }
            }
        },

        // Doe ค้นหา  3/6
        async searchTable() {
            if (this.filter !== '') {
                this.body_dataPDF = this.cloneTable.filter((item) => {
                    return item.org.includes(this.filter);
                });
                return this.body_dataPDF;
            } else {
                this.body_dataPDF = this.cloneTable;
            }
        },
        // Doe ค้นหา  3/6 จบ
        // กด search ครั้งแรก
        async search() {
            this.filter = '';
            this.cloneTable = [];
            this.setStandardName = null;
            var userVehicleSelected = this.vehicleSelected;
            var userDeviceTypeSelected = this.deviceTypeSelected;
            var userStandardNameSelected = this.standardNameSelected;

            console.log('organize_table', this.organize_table);
            if (this.organize_table.length === 0) {
                this.$fire({
                    title: 'กรุณาเลือกหน่วยงาน',
                    type: 'warning',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
                return;
            }

            if (this.vehicleSelected === null) {
                // this.error_text_default_vehicle = true

                // ถ้าประเภทยานพาหะนะไม่มีค่า ให้ '' เป็นค่าเริ่มต้น
                // console.log('this.vehicleSelected =',this.vehicleSelected)
                userVehicleSelected = '';
                // console.log('userVehicleSelected =',userVehicleSelected)
            }

            if (this.deviceTypeSelected !== null) {
                this.error_text_default = false;
            }
            if (this.deviceTypeSelected === null) {
                this.error_text_default = true;
            }

            if (this.standardNameSelected !== null) {
                this.error_text = false;
            }

            if (this.standardNameSelected === null) {
                // userStandardNameSelected = '';
                this.error_text = true;
            }
            // console.log(userStandardNameSelected)
            // if((this.deviceTypeSelected != null)&&(this.vehicleSelected != null)){
            if (this.deviceTypeSelected !== null && this.standardNameSelected !== null) {
                this.error_text_default_vehicle = false;
                this.error_text_default = false;
                this.error_text = false;
                this.loading = true;
                // console.log(this.organize_table)
                await this.axios
                    .post(`${this.$url_service}/get/report`, {
                        body: {
                            topic: 'get-report-equipment',
                            subtopic: 'get-report-equipment-investigation',
                            organize: this.organize_table,
                            device: userDeviceTypeSelected,
                            vehicle: userVehicleSelected,
                            standardName: userStandardNameSelected
                        }
                    })
                    .then((response) => {
                        this.table = response.data.data;

                        // Doe ค้นหา  4/6
                        this.cloneTable = response.data.data;
                        // Doe ค้นหา  4/6

                        // Doe : เพิ่ม ลำดับ 3/4
                        for (let i = 0; i < this.table.length; i++) {
                            this.table[i]['index'] = i + 1;
                        }
                        // Doe : เพิ่ม ลำดับ 3/4 จบ
                        //เพิ่ม จำนวน
                        // for (let i = 0; i < this.table.length; i++) {
                        //   const item = 1
                        //   this.table[i]["item"] =item;
                        // }
                        //เพิ่ม จำนวน จบ
                        // Doe : แก้ไข เวลา
                        for (let index = 0; index < this.table.length; index++) {
                            const element = this.table[index].ev_date.split('/');

                            let dateNew = new Date(`${element[1]}/${element[0]}/${element[2]}`);

                            this.table[index].ev_date = moment(dateNew).locale('th').add(543, 'year').format('LL');
                        }
                        // Doe : แก้ไข เวลา

                        // Doe ช่องว่างใส่ ขีด
                        for (let index = 0; index < this.table.length; index++) {
                            if (
                                this.table[index].status === 'ชำรุด' ||
                                this.table[index].status === 'ซ่อม' ||
                                this.table[index].status === 'จำหน่าย' ||
                                this.table[index].status === 'รอจำหน่าย'
                            ) {
                                this.table[index].status = 'ซ่อม/ชำรุด';
                            }
                            if (
                                this.table[index].ev_standard_name == null ||
                                this.table[index].ev_standard_name == 'null' ||
                                this.table[index].ev_standard_name == ''
                            ) {
                                this.table[index].ev_standard_name = '-';
                            }
                            // if(this.table[index].ev_amount === '0'){
                            //   this.table[index].ev_amount = 0
                            // }
                            if (this.table[index].ev_number == null || this.table[index].ev_number == 'null' || this.table[index].ev_number == '') {
                                this.table[index].ev_number = '-';
                            }
                            if (
                                this.table[index].ev_license_plate == null ||
                                this.table[index].ev_license_plate == 'null' ||
                                this.table[index].ev_license_plate == ''
                            ) {
                                this.table[index].ev_license_plate = '-';
                            }
                            if (
                                this.table[index].ev_sidecar_number == null ||
                                this.table[index].ev_sidecar_number == 'null' ||
                                this.table[index].ev_sidecar_number == ''
                            ) {
                                this.table[index].ev_sidecar_number = '-';
                            }
                            if (
                                this.table[index].ev_response_name == null ||
                                this.table[index].ev_response_name == 'null' ||
                                this.table[index].ev_response_name == ''
                            ) {
                                this.table[index].ev_response_name = '-';
                            }
                            if (
                                this.table[index].ev_response_phone == null ||
                                this.table[index].ev_response_phone == 'null' ||
                                this.table[index].ev_response_phone == ''
                            ) {
                                this.table[index].ev_response_phone = '-';
                            }
                            if (
                                this.table[index].text_tel_detail == null ||
                                this.table[index].text_tel_detail == 'null' ||
                                this.table[index].text_tel_detail == ''
                            ) {
                                this.table[index].text_tel_detail = '-';
                            }
                            if (this.table[index].ev_detail == null || this.table[index].ev_detail == 'null' || this.table[index].ev_detail == '') {
                                this.table[index].ev_detail = '-';
                            }
                        }
                        // Doe ช่องว่างใส่ ขีด

                        this.setSearchText_Footer();
                        if (this.table.length !== 0) {
                            // console.log(this.table)

                            this.format_PDF(this.table);
                        } else {
                            this.body_dataPDF = [];
                        }
                    });
                // !
                // console.log('this.table =',this.table);

                if (this.columns_disabled == true) {
                    this.table = this.cloneTable;
                } else {
                    this.table = [];
                }

                this.loading = false;
            } else {
                this.table = [];
                if (this.deviceTypeSelected == null) {
                    this.error_device = true;
                }
                if (this.vehicleSelected == null) {
                    this.error_vehicle = true;
                }
                if (this.standardNameSelected == null) {
                    this.error_standardName = true;
                }
            }
        },

        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);

            if (
                this.organize_table.length !== 0 ||
                this.deviceTypeSelected !== null ||
                this.vehicleSelected !== null ||
                this.standardNameSelected !== null
            ) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'หน่วยงานรับผิดชอบ' && this.organize_table.length !== 0) {
                        element.textShow = this.setArray_to_Text(this.organize_table, 'organize_name');
                    }
                    if (element.DataName === 'ประเภทเครื่องมือ/อุปกรณ์' && this.deviceTypeSelected !== null) {
                        element.textShow = this.setArray_to_Text(this.deviceTypeSelected, 'system_name');
                    }
                    if (element.DataName === 'ประเภทยานพาหนะ' && this.vehicleSelected !== null) {
                        element.textShow = this.setArray_to_Text(this.vehicleSelected, 'system_name');
                    }
                    if (element.DataName === 'ชื่อเครื่องมือฯ (ชื่อมาตรฐาน)' && this.standardNameSelected !== null) {
                        element.textShow = this.setArray_to_Text(this.standardNameSelected, 'system_name');
                    }

                    this.text_Footer = true;
                }
            }
        },
        setArray_to_Text(data, name) {
            let text = [];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (name !== null) {
                    if (element[name] !== undefined) {
                        text += element[name] + ',';
                    }
                } else {
                    text += element[name] + ',';
                }
            }
            return text.slice(0, -1);
        },

        confirmDelete() {
            this.displayConfirmation = false;
            this.organize_table = this.organize_table.filter((val) => val !== this.organizeDelete);
        },

        clearSearchField() {
            this.organize_table = [];
            this.deviceTypeSelected = null;
            this.vehicleSelected = null;
            this.standardNameSelected = null;
            this.error_device = false;
            this.error_vehicle = false;
            this.error_standardName = false;
            this.error_text = false;
            this.error_text_default = false;
            this.error_text_default_vehicle = false;
            this.multiSelectClearFilerValue += 1;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;
            // Doe ค้นหา
            this.filter = '';
            this.table = [];
            this.cloneTable = [];
        },
        alertDisplay(temp) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log("temp",temp)
                    this.confirmDelete(temp);
                }
            });
        },
        // กระจาย array เป็น object
        matchSelectStandard(element) {
            const arrDataGenerat = [];
            for (let ix = 0; ix < this.setStandardName.length; ix++) {
                const StandardName = this.setStandardName[ix];
                arrDataGenerat.push({ [StandardName.system_name]: element[StandardName.system_name] });
            }
            return arrDataGenerat.reduce((acc, item) => ({ ...acc, ...item }), {});
        },

        format_PDF(data_table) {
            // console.log(data_table)
            let data_table2 = data_table;
            const duplicated_lists = data_table.map((e) => e.organize_name);
            // console.log('this.organize_table', this.organize_table);
            if (this.organize_table.length > 0) {
                this.organize_table.forEach((element) => {
                    if (!duplicated_lists.includes(element.organize_name)) {
                        data_table2.push({
                            organize_name: element.organize_name,
                            ev_amount: '0',
                            //เพิ่มให่ม rod
                            sum: 0,
                            status: 'พร้อมใช้'
                        });
                        data_table2.push({
                            organize_name: element.organize_name,
                            ev_amount: '0',
                            //เพิ่มให่ม rod
                            sum: 0,
                            status: 'ซ่อม/ชำรุด'
                        });
                        duplicated_lists.push(element.organize_name); // Add to the duplicated list to avoid further duplicates
                    }
                });
            }
            // console.log(data_table)
            let head_PDF = [
                { title: 'หน่วยงาน', styles: { minCellWidth: 75, fillColor: [95, 154, 250] } },
                {
                    title: 'สถานะ',
                    styles: { minCellWidth: 35, fillColor: [95, 154, 250] }
                }
            ];
            let head_PDF_PDF = [
                { title: 'หน่วยงาน', styles: { minCellWidth: 75, fillColor: [95, 154, 250] } },
                {
                    title: 'สถานะ',
                    styles: { minCellWidth: 35, fillColor: [95, 154, 250] }
                }
            ];
            let column_PDF = [];
            let column_PDF_PDF = [];
            let body_data = [];
            let body_data_PDF = [];
            // let body_status = [
            //   {
            //     name_s: "พร้อมใช้",
            //   },
            //   {
            //     name_s: "ซ่อม",
            //   },
            //   {
            //     name_s: "ชำรุด",
            //   },
            //   {
            //     name_s: "รอจำหน่าย",
            //   },
            //   {
            //     name_s: "จำหน่าย",
            //   },
            // ];

            //    ไม่ใช่แล้ว
            // let body_status_PDF = [
            //     {
            //         name_s: 'พร้อมใช้'
            //     },
            //     {
            //         name_s: 'ซ่อม/ชำรุด'
            //     }
            // ];
            let Body_setCenter = [];
            let Body_rowSpan_PDF = [];
            let Body_rowSpan = [];

            // console.log("data_table",data_table)
            if (this.equipment_standard_name !== null) {
                let head_sName = [];
                let data_row = [];
                let data_organize_name = [];

                let head_sName_PDF = [];
                let data_row_PDF = [];
                let data_organize_name_PDF = [];
                // this.standardNameSelected คือที่เลือก
                this.standardNameSelected.forEach((item) => {
                    if (!head_sName.includes(item.system_name) && item.system_name !== null) {
                        head_sName.push(item.system_name);
                    }
                    if (!head_sName_PDF.includes(item.system_name) && item.system_name !== null) {
                        head_sName_PDF.push(item.system_name);
                    }
                });

                this.setStandardName = this.standardNameSelected;
                // console.log(this.setStandardName)
                for (let index = 0; index < data_table.length; index++) {
                    const element = data_table[index];

                    // เพิ่มหน่วนงาน
                    if (!data_organize_name.includes(element.organize_name) && element.organize_name !== null) {
                        data_organize_name.push(element);
                    }

                    //เช็คข้อมูลมีข้อมูล
                    if (element !== null) {
                        if (data_row.length === 0) {
                            const dataIsNotReadyObject = this.matchSelectStandard(element);
                            console.log('dataIsNotReadyObject', dataIsNotReadyObject);
                            data_row.push({
                                organize_name: element.organize_name,
                                data: [
                                    {
                                        ...dataIsNotReadyObject,
                                        name: element.ev_standard_name,
                                        count: 0,
                                        sum: element.sum,
                                        status: element.status,
                                        system_name: element.system_name
                                    }
                                ]
                            });
                        } else {
                            for (let index = 0; index < data_row.length; index++) {
                                const element_row = data_row[index];
                                if (!data_row.some((row) => row.organize_name === element.organize_name)) {
                                    const dataIsNotReadyObject = this.matchSelectStandard(element);
                                    data_row.push({
                                        organize_name: element.organize_name,
                                        data: [
                                            {
                                                ...dataIsNotReadyObject,
                                                name: element.ev_standard_name,
                                                count: 0,
                                                sum: element.sum,
                                                status: element.status,
                                                system_name: element.system_name
                                            }
                                        ]
                                    });
                                    break;
                                } else {
                                    for (let index2 = 0; index2 < element_row.data.length; index2++) {
                                        const element_data = element_row.data[index2];
                                        if (
                                            element_row.organize_name === element.organize_name &&
                                            !element_row.data.some((row) => row.name === element.ev_standard_name && row.status === element.status) // หา status
                                        ) {
                                            const dataIsNotReadyObject = this.matchSelectStandard(element);

                                            element_row.data.push({
                                                ...dataIsNotReadyObject,
                                                name: element.ev_standard_name,
                                                count: 0,
                                                sum: element.sum,
                                                status: element.status,
                                                system_name: element.system_name
                                            });
                                            break;
                                        } else if (
                                            element_data.name === element.ev_standard_name &&
                                            element_row.organize_name === element.organize_name &&
                                            element_data.status === element.status
                                        ) {
                                            // const num = parseFloat(element.ev_amount) + parseFloat(element_data.count);
                                            element_data.count = 0;
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                for (let index = 0; index < data_table2.length; index++) {
                    const element = data_table2[index];
                    if (!data_organize_name_PDF.includes(element.organize_main_name) && element.organize_name !== null) {
                        data_organize_name_PDF.push(element);
                    }

                    if (element !== null) {
                        if (data_row_PDF.length === 0) {
                            const dataIsNotReadyObject = this.matchSelectStandard(element);
                            data_row_PDF.push({
                                organize_main_name: element.organize_main_name,
                                data: [
                                    {
                                        ...dataIsNotReadyObject,
                                        name: element.ev_standard_name,
                                        count: 0,
                                        sum: element.sum,
                                        status: element.status,
                                        system_name: element.system_name
                                    }
                                ]
                            });
                        } else {
                            for (let index = 0; index < data_row_PDF.length; index++) {
                                const element_row = data_row_PDF[index];
                                if (!data_row_PDF.some((row) => row.organize_main_name === element.organize_main_name)) {
                                    const dataIsNotReadyObject = this.matchSelectStandard(element);
                                    data_row_PDF.push({
                                        organize_main_name: element.organize_main_name,
                                        data: [
                                            {
                                                ...dataIsNotReadyObject,
                                                name: element.ev_standard_name,
                                                count: 0,
                                                sum: element.sum,
                                                status: element.status,
                                                system_name: element.system_name
                                            }
                                        ]
                                    });
                                    break;
                                } else {
                                    for (let index2 = 0; index2 < element_row.data.length; index2++) {
                                        const element_data = element_row.data[index2];
                                        if (
                                            element_row.organize_main_name === element.organize_main_name &&
                                            !element_row.data.some((row) => row.name === element.ev_standard_name && row.status === element.status)
                                        ) {
                                            const dataIsNotReadyObject = this.matchSelectStandard(element);
                                            element_row.data.push({
                                                ...dataIsNotReadyObject,
                                                name: element.ev_standard_name,
                                                count: 0,
                                                sum: element.sum,
                                                status: element.status,
                                                system_name: element.system_name
                                            });
                                            break;
                                        } else if (
                                            element_data.name === element.ev_standard_name &&
                                            element_row.organize_main_name === element.organize_main_name &&
                                            element_data.status === element.status
                                        ) {
                                            element_data.count = 0;
                                            break;
                                        }
                                    }
                                }

                                // console.log(data_row)
                                // console.log(data_row_PDF)
                            }

                            // กรองข้อมูลที่ไม่รุ้จักออก
                            for (let index = 0; index < data_row_PDF.length; index++) {
                                // const element = data_row_PDF[index].organize_main_name
                                data_row_PDF = data_row_PDF.filter((item) => item.organize_main_name !== undefined);
                            }
                        }
                    }
                }
                // console.log(data_row)
                // console.log(data_row_PDF)

                let dataKey = [];
                let dataKey_PDF = [];
                for (let index = 0; index < head_sName.length; index++) {
                    const element = head_sName[index];
                    head_PDF.push({
                        title: element,
                        styles: { fillColor: [95, 154, 250] }
                    });
                    dataKey.push({ dataKey: element, styles: { halign: 'center' } });
                }

                // console.log("dataKey",dataKey)
                // head_PDF.push({
                //   title: "รวมรถ",
                //   styles: { fillColor: [95, 154, 250] },
                // });
                // head_PDF.push({
                //   title: "รวมอุปกรณ์",
                //   styles: { fillColor: [95, 154, 250] },
                // });
                // head_PDF.push({
                //   title: "รวมเรือ",
                //   styles: { fillColor: [95, 154, 250] },
                // });
                head_PDF.push({
                    title: 'รวม',
                    styles: { fillColor: [95, 154, 250] }
                });

                column_PDF.push({ dataKey: 'org', rowSpan: 5 }, { dataKey: 'status', styles: { cellWidth: '20', halign: 'center' } });

                for (let index = 0; index < dataKey.length; index++) {
                    const element = dataKey[index];
                    column_PDF.push(element);
                }

                // column_PDF.push(
                //   { dataKey: "sum_v" },
                //   { dataKey: "sum_d" },
                //   { dataKey: "sum_b" }
                // );
                column_PDF.push({ dataKey: 'sum' });

                for (let index = 0; index < head_sName_PDF.length; index++) {
                    const element = head_sName_PDF[index];
                    head_PDF_PDF.push({
                        title: element,
                        styles: { fillColor: [95, 154, 250] }
                    });
                    dataKey_PDF.push({ dataKey: element, styles: { halign: 'center' } });
                }
                head_PDF_PDF.push({
                    title: 'รวม',
                    styles: { fillColor: [95, 154, 250] }
                });

                column_PDF_PDF.push({ dataKey: 'org', rowSpan: 5 }, { dataKey: 'status', styles: { cellWidth: '20', halign: 'center' } });

                for (let index = 0; index < dataKey_PDF.length; index++) {
                    const element = dataKey_PDF[index];
                    column_PDF_PDF.push(element);
                }
                column_PDF_PDF.push({ dataKey: 'sum' });
                // console.log(column_PDF)
                // console.log(column_PDF_PDF)

                // console.log(head_PDF_PDF)

                for (let index = 0; index < data_organize_name.length; index++) {
                    const element = data_organize_name[index];

                    // for (let index2 = 0; index2 < body_status_PDF.length; index2++) {
                    //     const element_status = body_status_PDF[index2];
                    // console.log("element_status",element_status)
                    // body_data.push({ org: element, status: element_status.name_s });
                    body_data.push({ org: element.organize_name, ...element });
                    // }
                }

                for (let index = 0; index < data_organize_name_PDF.length; index++) {
                    const element = data_organize_name_PDF[index];

                    // for (let index2 = 0; index2 < body_status_PDF.length; index2++) {
                    //     const element_status = body_status_PDF[index2];
                    // console.log("element_status",element_status)
                    // body_data_PDF.push({ org: element, status: element_status.name_s });
                    body_data_PDF.push({ org: element.organize_name, status: element.status, ...element });

                    // }
                }

                // body มีแค่ชื่อ status
                for (let index = 0; index < body_data.length; index++) {
                    const element_body = body_data[index];

                    // data main [{organize_name,data:[]}]
                    for (let index3 = 0; index3 < data_row.length; index3++) {
                        // เอาชื่อหน่วยงาน
                        const element_row = data_row[index3].organize_name;
                        // เอา data ใส่ตัวแปร
                        const element_row_data = data_row[index3].data;
                        // loop เอา data เข้า body
                        for (let index4 = 0; index4 < element_row_data.length; index4++) {
                            const element_data = element_row_data[index4];
                            if (element_row === element_body.org && element_data.status === element_body.status) {
                                // element_body[element_data.name] = element_data.count.toLocaleString('en-US');
                                element_body[element_data.name] = element_data[element_data.name];
                            }

                            if (element_body.sum !== undefined && element_row === element_body.org && element_data.status === element_body.status) {
                                // const num = parseFloat(element_body['sum']) + parseFloat(element_data.count);
                                // element_body['sum'] = num.toLocaleString('en-US');

                                element_body['sum'] = element_data['sum'];
                            } else if (element_row === element_body.org && element_data.status === element_body.status) {
                                element_body['sum'] = element_data['sum'];
                            }
                        }
                    }
                }

                for (let index = 0; index < body_data_PDF.length; index++) {
                    const element_body = body_data_PDF[index];
                    for (let index3 = 0; index3 < data_row_PDF.length; index3++) {
                        // เอาชื่อหน่วยงาน
                        const element_row = data_row_PDF[index3].organize_main_name;
                        // เอา data ใส่ตัวแปร
                        const element_row_data = data_row_PDF[index3].data;
                        // loop เอา data เข้า body
                        for (let index4 = 0; index4 < element_row_data.length; index4++) {
                            const element_data = element_row_data[index4];
                            if (element_row === element_body.org && element_data.status === element_body.status) {
                                // element_body[element_data.name] = element_data.count.toLocaleString('en-US');
                                element_body[element_data.name] = element_data[element_data.name];
                            }

                            if (element_body.sum !== undefined && element_row === element_body.org && element_data.status === element_body.status) {
                                // const num = parseFloat(element_body['sum']) + parseFloat(element_data.count);
                                // element_body['sum'] = num.toLocaleString('en-US');
                                element_body['sum'] = element_data['sum'];
                            } else if (element_row === element_body.org && element_data.status === element_body.status) {
                                // element_body['sum'] = element_data.count.toLocaleString('en-US');
                                element_body['sum'] = element_data['sum'];
                            }
                        }
                    }
                }

                for (let index = 0; index < body_data_PDF.length; index++) {
                    body_data_PDF = body_data_PDF.filter((item) => item.org !== undefined);
                }

                column_PDF.forEach((element) => {
                    if (!element.dataKey.includes('org')) {
                        Body_setCenter.push(element.dataKey);
                    }
                });
                column_PDF_PDF.forEach((element) => {
                    if (!element.dataKey.includes('org')) {
                        Body_setCenter.push(element.dataKey);
                    }
                });
                column_PDF.forEach((element) => {
                    if (!element.dataKey.includes('org')) {
                        Body_setCenter.push(element.dataKey);
                    }
                });

                Body_rowSpan = [];
                for (let index = 0; index < data_organize_name.length; index++) {
                    const element_organize = data_organize_name[index];
                    Body_rowSpan.push({
                        dataKey: 'org',
                        raw: element_organize,
                        status: 'rowSpan',
                        num: '2',
                        halign: 'center',
                        valign: 'middle'
                    });
                }
                // console.log(Body_rowSpan)
                Body_rowSpan.push({
                    dataKey: 'org',
                    raw: 'รวม',
                    status: 'rowSpan',
                    num: '2',
                    halign: 'center',
                    valign: 'middle'
                });
                Body_rowSpan.push({
                    dataKey: 'org',
                    raw: 'รวมทั้งสิ้น',
                    status: 'colSpan',
                    num: '1',
                    halign: 'right',
                    valign: 'middle'
                });

                Body_rowSpan_PDF = [];
                // console.log(data_organize_name)
                for (let index = 0; index < data_organize_name_PDF.length; index++) {
                    const element_organize = data_organize_name_PDF[index];
                    if (element_organize !== undefined) {
                        Body_rowSpan_PDF.push({
                            dataKey: 'org',
                            raw: element_organize,
                            status: 'rowSpan',
                            num: '2',
                            halign: 'center',
                            valign: 'middle'
                        });
                    }
                }
                Body_rowSpan_PDF.push({
                    dataKey: 'org',
                    raw: 'รวม',
                    status: 'rowSpan',
                    num: '2',
                    halign: 'center',
                    valign: 'middle'
                });
                Body_rowSpan_PDF.push({
                    dataKey: 'org',
                    raw: 'รวมทั้งสิ้น',
                    status: 'colSpan',
                    num: '1',
                    halign: 'right',
                    valign: 'middle'
                });
            }
            // console.log(Body_rowSpan_PDF)
            const customSortOrder = { รวม: 1, รวมทั้งสิ้น: 2 };
            body_data.sort((a, b) => {
                const orgA = a.org || '';
                const orgB = b.org || '';

                // Get the custom sort order values (default to 0 if not found)
                const sortOrderA = customSortOrder[orgA] || 0;
                const sortOrderB = customSortOrder[orgB] || 0;

                // Sort based on the custom order or alphabetically
                return sortOrderA - sortOrderB || orgA.localeCompare(orgB);
            });

            body_data_PDF.sort((a, b) => {
                const orgA = a.org || '';
                const orgB = b.org || '';

                // Get the custom sort order values (default to 0 if not found)
                const sortOrderA = customSortOrder[orgA] || 0;
                const sortOrderB = customSortOrder[orgB] || 0;

                // Sort based on the custom order or alphabetically
                return sortOrderA - sortOrderB || orgA.localeCompare(orgB);
            });
            // console.log(body_data)

            // console.log(head_PDF_PDF)
            if (this.is_pressed === true) {
                this.head_PDF = head_PDF_PDF;
                this.column_PDF = column_PDF_PDF;
                this.body_dataPDF = body_data_PDF.sort((a, b) => b.number - a.number);
                this.body_data_PDF = body_data_PDF.sort((a, b) => b.number - a.number);
                this.cloneTable = this.setCloneData(body_data_PDF.sort((a, b) => b.number - a.number));
                this.Body_rowSpanPDF = Body_rowSpan_PDF;
                this.Body_setCenterPDF = Body_setCenter;
            }
            if (this.is_pressed === false) {
                this.head_PDF = head_PDF;
                this.column_PDF = column_PDF;
                this.body_dataPDF = body_data.sort((a, b) => b.number - a.number);
                this.body_data_PDF = body_data.sort((a, b) => b.number - a.number);
                this.cloneTable = this.setCloneData(body_data.sort((a, b) => b.number - a.number));

                this.Body_rowSpanPDF = Body_rowSpan;
                this.Body_setCenterPDF = Body_setCenter;
            }
        },

        generatePDF(head_PDF, data_PDf, data, PDF) {
            // console.log(data_PDf)
            const dateObj = new Date();
            let time = `${dateObj.getDate()}-${dateObj.getMonth() + 1}-${dateObj.getFullYear() + 543}`;
            const text_datePDF = `ข้อมูล ณ วันที่ ${this.changeDateToThai(dateObj)}`;
            const text_topic = 'สรุปรายงานความพร้อม เครื่องมือ อุปกรณ์/ยานพาหนะต่างๆ ของสำนักป้องกันและบรรเทาสาธารณภัย กรุงเทพมหานคร';
            const text_footer1 =
                'ที่มา : ฝ่ายการสื่อสารและสารสนเทศ ส่วนช่วยบัญชาการสาธารณภัย สำนักงานอำนวยการสาธารณภัย สำนักป้องกันและบรรเทาสาธารณภัย';
            const text_footer2 = 'กรุงเทพมหานคร สายด่วน 199 โทร. 02-354-6858';
            const datePDF_pos = [PDF.setPosition[0], PDF.setPosition[1]];
            const topicPDF_pos = [PDF.setPositionTopic[0], PDF.setPositionTopic[1]];
            const footerPDF_pos = [PDF.setPositionFooter[0], PDF.setPositionFooter[1]];

            const footerPDF_pos2 = [PDF.setPositionFooter2[0], PDF.setPositionFooter2[1]];

            // PDF.Body_rowSpan.forEach((item, index) => {
            //         item.raw = index + 1;
            //       });

            const doc = new jsPDF(PDF.streak, 'pt');
            doc.addFileToVFS('m.ttf', font);
            doc.addFont('m.ttf', 'm', 'normal');
            doc.setFont('m');
            doc.autoTable({
                head: [head_PDF],
                columns: data_PDf,
                body: data,
                margin: { left: 15, right: 15 },
                theme: 'grid',
                columnStyles: {
                    0: { cellWidth: 80 },
                    1: { cellWidth: 46 },
                    [data_PDf.length - 1]: { cellWidth: 28 }
                },
                styles: {
                    fontStyle: 'normal',
                    font: 'm'
                    // maxWidth: 100
                },
                headStyles: {
                    // fontSize: 0.0001,
                    fontSize: 14,
                    fontStyle: 'bolder',
                    halign: 'center',
                    valign: 'middle',
                    minCellHeight: 40
                    // cellWidth: 50,
                },
                bodyStyles: {
                    fontSize: 12
                },
                didParseCell: (HookData) => {
                    // console.log(HookData.cell.text,HookData)
                    if (
                        HookData.cell.text[0] == '' ||
                        HookData.cell.text[0] == null ||
                        HookData.cell.text[0] == 'null' ||
                        HookData.cell.text[0] == undefined ||
                        HookData.cell.text[0] == ' -'
                    ) {
                        HookData.cell.text = '-';
                        HookData.cell.styles.halign = 'center';
                        HookData.cell.styles.valign = 'middle';
                    }

                    if (PDF.checkBody_Center) {
                        const column = HookData.column.dataKey;
                        PDF.Body_Center.filter((item) => {
                            if (column === item) {
                                HookData.cell.styles.halign = 'center';
                            }
                        });
                    }

                    if (PDF.checkBody_rowSpan) {
                        for (let index = 0; index < PDF.Body_rowSpan.length; index++) {
                            const element = PDF.Body_rowSpan[index];
                            if (HookData.column.dataKey === element.dataKey) {
                                if (HookData.cell.raw === element.raw) {
                                    HookData.cell[element.status] = element.num;

                                    HookData.cell.styles.halign = element.halign;
                                    HookData.cell.styles.valign = element.valign;
                                }
                            }
                        }
                    }

                    if (PDF.check_fill_row !== undefined && PDF.check_fill_row !== false) {
                        const column = HookData.column.dataKey;
                        const row = HookData.cell.text;

                        for (let index = 0; index < PDF.fill_row_detail.length; index++) {
                            const element = PDF.fill_row_detail[index];
                            if (column == element.name_row) {
                                for (let index2 = 0; index2 < element.detail_row.length; index2++) {
                                    const element_fill = element.detail_row[index2];
                                    if (element_fill.check_text == row) {
                                        HookData.cell.styles.fillColor = element_fill.fill_color;
                                    }
                                }
                            }
                        }
                    }
                },
                // didDrawPage: () => {
                //         doc.setFontSize(13);
                //         doc.text(text_datePDF,datePDF_pos[0],datePDF_pos[1],null,null,"right")
                // }
                didDrawCell: function () {
                    // console.log(data)
                    doc.setFontSize(14);
                    doc.text(text_topic, topicPDF_pos[0], topicPDF_pos[1], null, null, 'center');

                    doc.setFontSize(10);
                    doc.text(text_datePDF, datePDF_pos[0], datePDF_pos[1], null, null, 'right');

                    doc.setFontSize(10);
                    doc.text(text_footer1, footerPDF_pos[0], footerPDF_pos[1], null, null, 'left');

                    doc.setFontSize(10);
                    doc.text(text_footer2, footerPDF_pos2[0], footerPDF_pos2[1], null, null, 'left');
                }
            });

            const pageCount = doc.internal.getNumberOfPages();
            const PageTo_pos = [PDF.setPosition[2], PDF.setPosition[3]];
            for (let index = 0; index < pageCount; index++) {
                doc.setPage(index);
                doc.setFontSize(13);
                let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;
                const text_PageTo = `หน้า ${pageCurrent} จาก ${pageCount}`;
                doc.text(text_PageTo, PageTo_pos[0], PageTo_pos[1], null, null, 'right');
            }
            const setPaper = PDF.streak === 'l' ? '(แนวนอน)' : '(แนวตั้ง)';
            doc.save(`${PDF.FileName} ${setPaper} ${time}.pdf`);
        },

        exportPDFVertical() {
            if (this.table == '') {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'PDF',
                    detail: 'ไม่มีข้อมูล',
                    life: 3000
                });
            } else {
                this.$toast.add({
                    severity: 'success',
                    summary: 'PDF',
                    detail: 'แนวตั้ง',
                    life: 3000
                });
                const setPDF = 'p';
                const dataMain = this.body_data_PDF.sort((a, b) => a.number - b.number);
                this.generatePDF1(this.setStandardName, this.organize_table, dataMain, setPDF);
            }
        },

        exportPDFHorizontal() {
            if (this.table == '') {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'PDF',
                    detail: 'ไม่มีข้อมูล',
                    life: 3000
                });
            } else {
                this.$toast.add({
                    severity: 'success',
                    summary: 'PDF',
                    detail: 'แนวนอน',
                    life: 3000
                });
                const setPDF = 'l';
                const dataMain = this.body_data_PDF.sort((a, b) => a.number - b.number);
                this.generatePDF1(this.setStandardName, this.organize_table, dataMain, setPDF);
            }
        },

        generatePDF1(setStandardName, organize_table, body_dataPDF, orientation) {
            const doc = new jsPDF(orientation, 'pt', 'a4');
            doc.addFileToVFS('THSarabunNew.ttf', font);
            doc.addFont('THSarabunNew.ttf', 'THSarabunNew', 'normal');
            doc.setFont('THSarabunNew');

            const getUniqueOrgs = () => organize_table.map((org) => org.organize_name);
            const uniqueOrgs = getUniqueOrgs();

            let startY = 40;
            const pageWidth = doc.internal.pageSize.getWidth();

            // Title
            doc.setFontSize(14);
            doc.text('สรุปรายงานความพร้อม เครื่องมือ อุปกรณ์/ยานพาหนะต่างๆ ของสำนักป้องกันและบรรเทาสาธารณภัย กรุงเทพมหานคร', pageWidth / 2, startY, {
                align: 'center'
            });
            startY += 30;

            const dateObj = new Date();
            let time = `${dateObj.getDate()}-${dateObj.getMonth() + 1}-${dateObj.getFullYear() + 543}`;

            // Set a smaller font size
            doc.setFontSize(10);

            doc.text(`ข้อมูล ณ วันที่ ${this.changeDateToThai(dateObj)}`, pageWidth - 10, startY, {
                align: 'right'
            });
            startY += 20;

            setStandardName.forEach((stan_name, standardIndex) => {
                const tableData = this.groupedByOrgAndStandardWithSum1(stan_name.system_name, uniqueOrgs, body_dataPDF);

                // Subtitle for each standard
                doc.setFontSize(12);
                doc.text(stan_name.system_name, 40, startY);
                startY += 20;

                // Table headers
                const headers = [['หน่วยงาน', 'พร้อมใช้', 'ซ่อมแซม/ชำรุด', 'รวม']];

                // Prepare table body
                const body = uniqueOrgs.map((org) => {
                    const readyData = tableData.find((row) => row.org === org && row.status === 'พร้อมใช้') || { value: 0 };
                    const repairData = tableData.find((row) => row.org === org && row.status === 'ซ่อม/ชำรุด') || { value: 0 };

                    const readyValue = parseInt(readyData.value) || 0;
                    const repairValue = parseInt(repairData.value) || 0;
                    const rowSum = readyValue + repairValue;

                    if (rowSum === 0) {
                        return [org, `ไม่มี${stan_name.system_name}`, '', ''];
                    } else {
                        return [org, readyValue.toString(), repairValue.toString(), rowSum.toString()];
                    }
                });

                // Generate table
                doc.autoTable({
                    head: headers,
                    body: body,
                    startY: startY,
                    styles: {
                        font: 'THSarabunNew',
                        fontSize: 10,
                        halign: 'center', // Align content to center
                        valign: 'middle', // Vertically align content to middle
                        lineWidth: 0.1, // Border width
                        lineColor: [0, 0, 0] // Border color
                    },
                    headStyles: {
                        fillColor: [200, 200, 200],
                        textColor: 20,
                        fontStyle: 'bold',
                        halign: 'center', // Align header content to center
                        valign: 'middle' // Vertically align header content to middle
                    },
                    columnStyles: {
                        0: { cellWidth: 'auto', halign: 'left' },
                        1: { cellWidth: 'auto', halign: 'center' },
                        2: { cellWidth: 'auto', halign: 'center' },
                        3: { cellWidth: 'auto', halign: 'center' }
                    },
                    didParseCell: function (data) {
                        if (data.section === 'body' && data.column.index > 0 && data.cell.raw === `ไม่มี${stan_name.system_name}`) {
                            data.cell.colSpan = 3;
                            data.cell.styles.halign = 'center';
                        }
                    },
                    didDrawPage: function (data) {
                        // Footer
                        let str = `หน้า ${doc.internal.getNumberOfPages()}`;
                        const text_footer1 =
                            'ที่มา : ฝ่ายการสื่อสารและสารสนเทศ ส่วนช่วยบัญชาการสาธารณภัย สำนักงานอำนวยการสาธารณภัย สำนักป้องกันและบรรเทาสาธารณภัย';
                        const text_footer2 = 'กรุงเทพมหานคร สายด่วน 199 โทร. 02-354-6858';
                        doc.setFontSize(10);
                        // Align page number to the right
                        doc.text(str, doc.internal.pageSize.getWidth() - data.settings.margin.right, doc.internal.pageSize.getHeight() - 10, {
                            align: 'right'
                        });
                        // Align footer text to the left
                        doc.text(text_footer1, data.settings.margin.left, doc.internal.pageSize.getHeight() - 20);
                        doc.text(text_footer2, data.settings.margin.left, doc.internal.pageSize.getHeight() - 30);
                    }
                });

                startY = doc.lastAutoTable.finalY + 30;

                // Check if we need to add a new page
                if (startY > doc.internal.pageSize.getHeight() - 50) {
                    doc.addPage();
                    startY = 40;
                }
            });

            // Save the PDF
            doc.save(`ตารางสรุปรายงานความพร้อมเครื่องมือ-${new Date().toISOString().split('T')[0]}.pdf`);
        },
        groupedByOrgAndStandardWithSum1(standardName, allOrgs, body_dataPDF) {
            const orgDataMap = new Map();

            body_dataPDF
                .filter((item) => item[standardName])
                .forEach((item) => {
                    if (item.org !== 'รวม' && item.org !== 'รวมทั้งสิ้น') {
                        const existingData = orgDataMap.get(item.org) || {
                            org: item.org,
                            ready: 0,
                            repair: 0,
                            value: 0,
                            sum: 0
                        };

                        if (item.status === 'พร้อมใช้') {
                            existingData.ready += parseInt(item[standardName]) || 0;
                        } else if (item.status === 'ซ่อม/ชำรุด') {
                            existingData.repair += parseInt(item[standardName]) || 0;
                        }

                        existingData.value += parseInt(item[standardName]) || 0;
                        existingData.sum += parseInt(item.sum) || 0;

                        orgDataMap.set(item.org, existingData);
                    }
                });

            const finalData = allOrgs.map((org) => {
                const data = orgDataMap.get(org) || {
                    org: org,
                    ready: 0,
                    repair: 0,
                    value: 0,
                    sum: 0
                };
                return {
                    org: data.org,
                    status: data.ready > data.repair ? 'พร้อมใช้' : 'ซ่อม/ชำรุด',
                    value: data.value,
                    sum: data.sum
                };
            });

            const totalRow = {
                org: 'รวมทั้งสิ้น',
                status: 'รวม',
                value: finalData.reduce((sum, item) => sum + item.value, 0),
                sum: finalData.reduce((sum, item) => sum + item.sum, 0)
            };

            return [...finalData, totalRow];
        },

        exportPDF_test() {
            this.generatePDF1(this.setStandardName, this.organize_table, this.body_dataPDF);
        }
    }
};
</script>

<style scoped>
.table_statusColor {
    color: #090073;
    display: inline-flex;
    padding: 5px 15px 5px 15px;
    font-weight: bolder;
    border-radius: 10px;
}
.table_row {
    text-align: center;
}

@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* // Doe PDF เลือกได้ */
#TABLE_EDIT {
    width: 149px;
}
@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}
.p-field {
    margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-dialog) {
    @media screen and (max-width: 991px) {
        .p-dialog-content {
            overflow-y: auto;
        }
    }
}
.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}

@import url(https://fonts.googleapis.com/css?family=Lato:300,400,700);

body {
    background: #fb887c;
    color: #fff;
    font-family: 'Lato', Arial, sans-serif;
}

h1 {
    font-family: 'proxima-nova', sans-serif;
    letter-spacing: -0.01em;
    font-weight: 700;
    font-style: normal;
    font-size: 60px;
    margin-left: -3px;
    line-height: 1em;
    color: #fff;
    text-align: center;
    margin-bottom: 8px;
    text-rendering: optimizeLegibility;
}

table {
    width: 80%;
    margin: auto;
}

table,
th,
td {
    border: 1px solid #fff;
    border-collapse: collapse;
}

th,
td {
    padding: 15px;
}
</style>
